var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-alert',{staticClass:"ma-3 mb-0",attrs:{"rounded":"","color":"warning","icon":"mdi-earth-off"}},[_c('span',{staticClass:"p-text warning--text"},[_vm._v("No shipping outside of South Africa")])])
}
var staticRenderFns = []

export { render, staticRenderFns }